import React from "react";

/**
 * Skip-Links für bessere Keyboard-Navigation
 * Ermöglicht es Benutzern, direkt zu wichtigen Bereichen zu springen
 * Wichtig für Screen Reader und Keyboard-Navigation
 */
export default function SkipLinks() {
  const handleSkipClick = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
      target.focus();
    }
  };

  return (
    <div className="skip-links">
      <a 
        href="#main-content" 
        className="skip-link skip-link-1"
        aria-label="Zum Hauptinhalt springen"
        onClick={(e) => handleSkipClick(e, 'main-content')}
        onFocus={(e) => {
          e.target.style.top = '0';
          e.target.style.zIndex = '10010';
        }}
        onBlur={(e) => {
          e.target.style.zIndex = '10001';
        }}
      >
        Zum Hauptinhalt springen
      </a>
      <a 
        href="#booking-section" 
        className="skip-link skip-link-2"
        aria-label="Zur Buchungssektion springen"
        onClick={(e) => handleSkipClick(e, 'booking-section')}
        onFocus={(e) => {
          e.target.style.top = '0';
          e.target.style.zIndex = '10010';
        }}
        onBlur={(e) => {
          e.target.style.zIndex = '10002';
        }}
      >
        Zur Buchung springen
      </a>
      <a 
        href="#navigation" 
        className="skip-link skip-link-3"
        aria-label="Zur Navigation springen"
        onClick={(e) => handleSkipClick(e, 'navigation')}
        onFocus={(e) => {
          e.target.style.top = '0';
          e.target.style.zIndex = '10010';
        }}
        onBlur={(e) => {
          e.target.style.zIndex = '10003';
        }}
      >
        Zur Navigation springen
      </a>
    </div>
  );
}
